var _line, _rect, _line2, _path, _circle, _circle2, _ellipse, _circle3, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesDraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 48,
    x2: 0.500002,
    y2: 88,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 41.7573,
    width: 6,
    height: 6,
    transform: "rotate(45 86 41.7573)",
    fill: "#F7F0F0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 2.18557e-8,
    x2: 109.5,
    y2: 40,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.1674 48.9751C92.1674 69.4942 75.601 84.9298 55.1654 84.9298C34.7297 84.9298 18.1633 68.2958 18.1633 47.7766C18.1633 27.2574 34.7297 10.6233 55.1654 10.6233C58.6835 10.6233 62.9238 11.007 65.3111 13.0203C75.4568 23.2075 55.1654 25.6044 65.3111 36.9901C75.4568 48.3758 79.0376 29.7992 87.3929 34.5931C92.5226 37.5364 92.1674 44.7815 92.1674 48.9751Z",
    fill: "#EADDDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6639,
    cy: 33.9337,
    r: 6.56586,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.286,
    cy: 51.768,
    r: 6.56586,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7967,
    cy: 67.3715,
    rx: 6.56586,
    ry: 6.71448,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3203,
    cy: 72.8011,
    r: 6.71448,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4726 84.3372L61.1145 50.7955L48.1828 31.2343L47.6747 30.4657L38.704 17.5778C36.6858 16.8513 35.3165 14.2169 33.7151 11.6417C31.809 8.57658 30.2229 3.0697 30.2229 3.0697C30.2229 3.0697 34.8191 6.20815 37.2073 9.12054C39.0636 11.3843 41.3882 13.4536 41.4972 15.6015L50.6519 28.3242L51.1762 29.0528L65.0379 48.3171L88.0882 82.3544C88.0882 82.3544 88.5067 83.0947 88.0882 83.8138C87.9836 83.9935 87.8266 84.172 87.5978 84.3372C86.4534 85.1634 85.4726 84.3372 85.4726 84.3372Z",
    fill: "#EA5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0058 18.0167L41.799 16.0405",
    stroke: "#333333",
    strokeWidth: 1.02326
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6745 30.4655L50.6517 28.3241",
    stroke: "#333333",
    strokeWidth: 1.02326
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesDraw);
export default __webpack_public_path__ + "static/media/categoriesDraw.4a2979828f253d90db52c0dc985fe210.svg";
export { ForwardRef as ReactComponent };